import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPencil = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "-8 -8 40 40",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "currentColor",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("path", { d: "M19.466 1.003a.375.375 0 0 1 .53 0l3.01 3.01a.375.375 0 0 1 0 .53l-2.353 2.35a.375.375 0 1 1-.53-.53l2.088-2.085-2.48-2.48-2.087 2.086a.375.375 0 1 1-.53-.53z" }), /* @__PURE__ */ _jsx("path", { d: "M17.114 3.353a.375.375 0 0 1 .53 0l3.01 3.01a.375.375 0 0 1-.001.53L6.927 20.603a.4.4 0 0 1-.113.078l-5.403 2.394a.375.375 0 0 1-.495-.495l2.394-5.403a.4.4 0 0 1 .077-.113zM3.774 17.981l-1.779 4.014 4.015-1.778zm2.888 1.827L4.183 17.33 17.379 4.15l2.479 2.479z" })]
	})
});
export default SvgPencil;
